import React from 'react';
import { PhoneIcon } from 'lucide-react';
export function StickyTopBar() {
  return <div className="bg-steel-950 text-steel-200 py-2 px-4 text-sm font-body z-50 relative" data-id="element-99">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-100">
        <div className="hidden md:block text-steel-300" data-id="element-101">
          Both dustless blasting (low mess) and dry blasting services. Fast
          turnaround.
        </div>
        <div className="flex items-center justify-end w-full md:w-auto space-x-6" data-id="element-102">
          <a href="tel:5177778088" className="flex items-center font-bold text-white hover:text-brand-red transition-colors" aria-label="Call Merem Blasting at (517) 777-8088" data-id="element-103">
            <PhoneIcon className="w-4 h-4 mr-2 text-brand-red" data-id="element-104" />
            (517) 777-8088
          </a>
          <a href="#quote" className="hidden sm:inline-block bg-brand-red text-white px-4 py-1 rounded-sm font-heading uppercase tracking-wide text-xs font-bold hover:bg-brand-red-dark transition-colors" data-id="element-105">
            Get a Fast Quote
          </a>
        </div>
      </div>
    </div>;
}